import { EnumBuilder } from '@mntn-dev/utility-types'
import type { z } from 'zod'
/**
 * BillingSchedule
 */
export const [BillingSchedules, BillingScheduleSchema, BillingSchedule] =
  EnumBuilder('100_up_front', '50_50')

export type BillingSchedule = z.infer<typeof BillingScheduleSchema>
